import React from 'react';

const initialContext = {};
export const LayoutContext = React.createContext(initialContext);

export interface ILayoutConsumerState {
    setDecorate: (value: boolean) => void;
    setWithoutSidebar: (value: boolean) => void;
    setWithoutHeader: (value: boolean) => void;
    setWithoutFooter: (value: boolean) => void;
    setFullScreen: (fullScreen: boolean) => void;
}
